import type { FC } from "react";
type ModalActionProps = React.HTMLAttributes<HTMLDivElement> & { className?: string };

const ModalAction: FC<ModalActionProps> = ({ className = "", ...props }) => (
  <div className={`mt-4 flex justify-end gap-4 ${className}`.trim()} {...props} />
);

export default ModalAction;
